// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// ========================================
// Protect Fitment Table from Convermax Manipulation
// This removes Convermax-specific identifiers so the app doesn't process the table
// ========================================
(function protectFitmentTable() {
  function sanitizeFitmentTable() {
    // Find fitment tables inside our product-fitment-table wrapper
    const tables = document.querySelectorAll('.product-fitment-table #cm-fitment-table, .product-fitment-table .cm_fitment-table');
    
    tables.forEach(function(table) {
      // Skip if already sanitized
      if (table.hasAttribute('data-sanitized')) return;
      table.setAttribute('data-sanitized', 'true');
      
      // Remove the cm-fitment-table ID that Convermax looks for
      if (table.id === 'cm-fitment-table') {
        table.removeAttribute('id');
        table.classList.add('product-fitment-table-content');
      }
      
      // Remove Convermax-specific classes that trigger JS processing
      // but keep the structural classes for our CSS
      const elementsWithCmClasses = table.querySelectorAll('[class*="cm_"], [class*="cmTemplate"], [class*="cmRepeater"]');
      elementsWithCmClasses.forEach(function(el) {
        const classes = Array.from(el.classList);
        classes.forEach(function(cls) {
          // Remove classes that start with cm_ (except cm_fitment which we style)
          // Remove cmTemplate and cmRepeater classes entirely
          if (cls.startsWith('cmTemplate') || cls.startsWith('cmRepeater')) {
            el.classList.remove(cls);
          }
        });
      });
      
      // Remove collapsed class and inline hiding styles
      const collapsedElements = table.querySelectorAll('.collapsed, [style*="height: 0"], [style*="overflow: hidden"]');
      collapsedElements.forEach(function(el) {
        el.classList.remove('collapsed');
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('position');
      });
    });
  }
  
  // Run immediately
  sanitizeFitmentTable();
  
  // Run on DOMContentLoaded (in case script runs before DOM is ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sanitizeFitmentTable);
  }
  
  // Run again after a short delay to catch any late-loaded content
  setTimeout(sanitizeFitmentTable, 100);
  setTimeout(sanitizeFitmentTable, 500);
})();

// ========================================
// Fitment Table - View More Functionality (10 rows at a time)
// ========================================
(function() {
  const ROWS_PER_PAGE = 10;

  function initFitmentViewMore() {
    const fitmentTables = document.querySelectorAll('.product-fitment-table');
    
    fitmentTables.forEach(function(tableWrapper) {
      // Skip if already initialized
      if (tableWrapper.hasAttribute('data-fitment-initialized')) return;
      tableWrapper.setAttribute('data-fitment-initialized', 'true');
      
      // Get ALL data rows from ALL fitment containers (there can be multiple)
      // Exclude header rows by targeting only .fitment-table-fitment containers
      const allRows = tableWrapper.querySelectorAll('.fitment-table-fitment .fitment-row');
      const totalRows = allRows.length;
      
      // Only add view more if there are more than ROWS_PER_PAGE rows
      if (totalRows <= ROWS_PER_PAGE) return;
      
      // Mark the table as having view more active
      tableWrapper.classList.add('fitment-table--paginated');
      
      let visibleCount = ROWS_PER_PAGE;
      
      // Initially hide rows beyond the first 10 using CSS class
      updateRowVisibility(allRows, visibleCount);
      
      // Create and insert the View More button
      const buttonWrapper = document.createElement('div');
      buttonWrapper.className = 'fitment-view-more-wrapper';
      
      const viewMoreBtn = document.createElement('button');
      viewMoreBtn.type = 'button';
      viewMoreBtn.className = 'fitment-view-more-btn';
      updateButtonText(viewMoreBtn, totalRows, visibleCount);
      
      buttonWrapper.appendChild(viewMoreBtn);
      
      // Insert button after the table
      const tableContainer = tableWrapper.querySelector('.cm_fitment-table, .fitment-table-container');
      if (tableContainer) {
        tableContainer.after(buttonWrapper);
      } else {
        tableWrapper.appendChild(buttonWrapper);
      }
      
      // Handle click
      viewMoreBtn.addEventListener('click', function() {
        visibleCount = Math.min(visibleCount + ROWS_PER_PAGE, totalRows);
        updateRowVisibility(allRows, visibleCount);
        updateButtonText(viewMoreBtn, totalRows, visibleCount);
        
        // Hide button if all rows are visible
        if (visibleCount >= totalRows) {
          buttonWrapper.style.display = 'none';
        }
      });
    });
  }

  function updateRowVisibility(rows, visibleCount) {
    for (var i = 0; i < rows.length; i++) {
      if (i < visibleCount) {
        rows[i].classList.remove('fitment-row--hidden');
      } else {
        rows[i].classList.add('fitment-row--hidden');
      }
    }
  }

  function updateButtonText(button, totalRows, visibleCount) {
    const remaining = totalRows - visibleCount;
    if (remaining > 0) {
      button.textContent = 'View More (' + remaining + ' remaining)';
    }
  }

  // Initialize after sanitization is complete
  function scheduleInit() {
    setTimeout(initFitmentViewMore, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();

// ========================================
// Suspension Table - View More Functionality (5 rows at a time)
// ========================================
(function() {
  var ROWS_PER_PAGE = 5;

  function initSuspensionViewMore() {
    var suspensionTables = document.querySelectorAll('.cm_suspension_table, #cm-suspension-table');

    suspensionTables.forEach(function(tableWrapper) {
      if (tableWrapper.hasAttribute('data-suspension-initialized')) return;
      tableWrapper.setAttribute('data-suspension-initialized', 'true');

      var allRows = tableWrapper.querySelectorAll('.suspension-table-data .suspension-row');
      var totalRows = allRows.length;

      if (totalRows <= ROWS_PER_PAGE) return;

      var visibleCount = ROWS_PER_PAGE;

      updateRowVisibility(allRows, visibleCount);

      var buttonWrapper = document.createElement('div');
      buttonWrapper.className = 'suspension-view-more-wrapper';

      var viewMoreBtn = document.createElement('button');
      viewMoreBtn.type = 'button';
      viewMoreBtn.className = 'suspension-view-more-btn';
      updateButtonText(viewMoreBtn, totalRows, visibleCount);

      buttonWrapper.appendChild(viewMoreBtn);

      var tableContainer = tableWrapper.querySelector('.suspension-table-container');
      if (tableContainer) {
        tableContainer.after(buttonWrapper);
      } else {
        tableWrapper.appendChild(buttonWrapper);
      }

      viewMoreBtn.addEventListener('click', function() {
        visibleCount = Math.min(visibleCount + ROWS_PER_PAGE, totalRows);
        updateRowVisibility(allRows, visibleCount);
        updateButtonText(viewMoreBtn, totalRows, visibleCount);

        if (visibleCount >= totalRows) {
          buttonWrapper.style.display = 'none';
        }
      });
    });
  }

  function updateRowVisibility(rows, visibleCount) {
    for (var i = 0; i < rows.length; i++) {
      if (i < visibleCount) {
        rows[i].classList.remove('suspension-row--hidden');
      } else {
        rows[i].classList.add('suspension-row--hidden');
      }
    }
  }

  function updateButtonText(button, totalRows, visibleCount) {
    var remaining = totalRows - visibleCount;
    if (remaining > 0) {
      button.textContent = 'View More (' + remaining + ' remaining)';
    }
  }

  function scheduleInit() {
    setTimeout(initSuspensionViewMore, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  applyZeroPriceProductState(evt.detail.variant);
});

// ========================================
// Zero Price Tag Products (zeroprice / btrclick)
// Hide add-to-cart and show "Choose an option" until a paid variant is selected
// ========================================
(function () {
  function isZeroPricePendingVariant(variant) {
    return variant && variant.price === 0;
  }

  function getZeroPriceProducts() {
    return document.querySelectorAll('[data-zero-price-tag="true"]');
  }

  window.applyZeroPriceProductState = function (variant) {
    getZeroPriceProducts().forEach(function (product) {
      var chooseLabel =
        product.getAttribute("data-zero-price-choose-label") || "Choose an option";
      var pending = isZeroPricePendingVariant(variant);

      product.classList.toggle("product--zero-price-pending", pending);

      if (pending) {
        product.querySelectorAll("[data-price]").forEach(function (el) {
          el.textContent = chooseLabel;
        });
        product.querySelectorAll("[data-compare-price]").forEach(function (el) {
          el.textContent = "";
        });
      }
    });
  };

  function bindZeroPriceForms(product) {
    if (product.hasAttribute("data-zero-price-form-bound")) return;
    product.setAttribute("data-zero-price-form-bound", "true");

    var form = product.querySelector("[data-product-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (product.classList.contains("product--zero-price-pending")) {
          e.preventDefault();
        }
      });
    }
  }

  function initZeroPriceProducts() {
    getZeroPriceProducts().forEach(bindZeroPriceForms);
  }

  function blockProtectedListingQuickAdd(event) {
    var quickAddBtn = event.target.closest('[data-quick-shop-trigger="quick-add"]');
    if (!quickAddBtn) return;

    var card = quickAddBtn.closest("[data-zero-price-protected]");
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var productLink = card.querySelector('a[href*="/products/"]');
    if (productLink) {
      window.location.href = productLink.href;
    }
  }

  function blockProtectedListingFormSubmit(event) {
    var form = event.target.closest(".product-item__product-form");
    if (!form) return;

    var card = form.closest("[data-zero-price-protected]");
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
  }

  document.addEventListener("click", blockProtectedListingQuickAdd, true);
  document.addEventListener("submit", blockProtectedListingFormSubmit, true);

  document.addEventListener("quickview:loaded", initZeroPriceProducts);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZeroPriceProducts);
  } else {
    initZeroPriceProducts();
  }
})();

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ========================================
// Filter List - View More/Less Functionality (10 at a time)
// ========================================
(function() {
  const ITEMS_PER_PAGE = 10;

  function initFilterViewMore() {
    const viewMoreButtons = document.querySelectorAll('[data-filter-view-more]');
    
    viewMoreButtons.forEach(function(button) {
      // Skip if already initialized
      if (button.hasAttribute('data-initialized')) return;
      button.setAttribute('data-initialized', 'true');
      
      const filterList = button.previousElementSibling;
      const allItems = filterList.querySelectorAll('li');
      const totalItems = allItems.length;
      
      // Initialize: show first 10, hide rest
      let visibleCount = ITEMS_PER_PAGE;
      updateVisibility(allItems, visibleCount);
      updateButtonText(button, totalItems, visibleCount);
      
      button.addEventListener('click', function() {
        // Show 10 more items
        visibleCount = Math.min(visibleCount + ITEMS_PER_PAGE, totalItems);
        updateVisibility(allItems, visibleCount);
        updateButtonText(button, totalItems, visibleCount);
        
        // Hide button if all items are visible
        if (visibleCount >= totalItems) {
          button.style.display = 'none';
        }
      });
    });
  }

  function updateVisibility(items, visibleCount) {
    items.forEach(function(item, index) {
      if (index < visibleCount) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  function updateButtonText(button, totalItems, visibleCount) {
    const remaining = totalItems - visibleCount;
    const viewMoreText = button.querySelector('[data-view-more-text]');
    if (viewMoreText && remaining > 0) {
      const showNext = Math.min(remaining, ITEMS_PER_PAGE);
      viewMoreText.textContent = 'View More (' + remaining + ')';
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterViewMore);
  } else {
    initFilterViewMore();
  }

  // Re-initialize after AJAX filter updates
  document.addEventListener('collection:filter-update', initFilterViewMore);
  
  // Also listen for any partial page updates (common in Shopify themes)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-filter-view-more]')) {
            initFilterViewMore();
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
